import { AccountingDocType, OrderType, OrderStatus } from "./enums";
import { Dayjs } from "dayjs";

export class AccountingFilterRequest {
    pageIndex = 0;
    orderBy: string = "";
    orderAsc = false;
    keywords = "";
    providerName = "";
    fromDate: Dayjs | null = null;
    toDate: Dayjs | null = null;
    docType: AccountingDocType | null = null;
}

export class AccountingDocSearchItem {
    baseAccountingDocumentId = 0;
    documentNumber = 0;
    externalSystem = "";
    docType: AccountingDocType = AccountingDocType.Invoice;
    total = 0;
    currencyId = 0;
    issueDate = "";
    createdAt = "";
    updatedAt = "";
    recipientName = "";
    providerName = "";
}

export interface AccountingFilterResponse {
    total: number;
    totalFilter: number;
    hasNext: boolean;
    accountingDocuments: AccountingDocSearchItem[];
}

export class AccountingDetailsFilterRequest {
    keywords = "";
    fromDate: Dayjs | null = null;
    toDate: Dayjs | null = null;
    orderType: OrderType | null = null;
    orderAsc: boolean = false;
    orderBy: string = "";
    invoiceDocumentId = 0;
    receiptDocumentId = 0;
}

export interface InvoiceDetails {
    baseAccountingDocumentId: number;
    documentNumber: number;
    externalSystem: string;
    recipientName: string;
    providerName: string;
    total: number;
    extraTotalAmount: number;
    servicesTotalAmount: number;
    currencyId: number;
    createdAt: string;
    connectedOrdersQty: number;
    docType: AccountingDocType;
    orders: InvoiceDocumentOrder[];
}

export interface InvoiceDocumentOrder {
    id: number;
    docket: string;
    externalSystem: string;
    status: OrderStatus;
    type: OrderType;
    amount: number;
    total: number;
    currencyId: number;
    paidByWallet: number;
    paidByEmployee: number;
    createdAt: string;
    updatedAt: string;
    employeeName: string;
}

export interface ReceiptDetails {
    baseAccountingDocumentId: number;
    documentNumber: number;
    externalSystem: string;
    recipientName: string;
    providerName: string;
    for: string;
    total: number;
    currencyId: number;
    issueDate: string;
    connectedInvoicesQty: number;
    docType: AccountingDocType;
    invoices: ReceiptDocumentInvoice[];
}

export interface ReceiptDocumentInvoice {
    id: number;
    documentNumber: string;
    externalSystem: string;
    recipientName: string;
    total: number;
    currencyId: number;
    vatPercent: number;
    vatAmount: number;
    excludeVatAmount: number;
    extraTotalAmount: number;
    servicesTotalAmount: number;
    for: string;
    issueDate: string;
    createdAt: string;
}
